// Libraries
import { createContext, ReactNode, useContext, useMemo, useState } from "react";

// Types
import { ReconciliationSectionContextValue } from "@/DataPages/types/inventory/commons";
import { IReconciliation } from "@/DataPages/types/inventory/models/reconciliation";

// Helpers
import { getFilteredReconciliationData } from "@/DataPages/components/Inventory/helpers/reconciliation";

const ReconciliationSectionContext = createContext<ReconciliationSectionContextValue>({} as ReconciliationSectionContextValue);

type ReconciliationSectionProviderProps = {
	children: ReactNode;
	data: IReconciliation[];
};

function ReconciliationSectionProvider({ children, data }: Readonly<ReconciliationSectionProviderProps>) {
	const [filterValues, setFilterValues] = useState<string[]>([]);

	const value = useMemo(
		() => ({ filterValues, setFilterValues, filteredData: getFilteredReconciliationData(filterValues, data), unFilteredData: data }),
		[filterValues, setFilterValues, data]
	);

	return <ReconciliationSectionContext.Provider value={value}>{children}</ReconciliationSectionContext.Provider>;
}

function useReconciliationSection() {
	const context = useContext(ReconciliationSectionContext);
	if (context === undefined) {
		throw new Error("useReconciliationSection must be used within a ReconciliationSectionProvider");
	}
	return context;
}

export { ReconciliationSectionProvider, useReconciliationSection };
